export const nameDayFrag = `
    id
    date
    month
    day
    name
    isHoliday
    holidayName
`;
